//imports
import {
    PACKAGES_OVERVIEW_REQUEST,
    PACKAGES_OVERVIEW_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    currentPackage: null,
    loading: false,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PACKAGES_OVERVIEW_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_OVERVIEW_RESULT:
            return { ...state, loading: false, currentPackage: action.payload }

        case CLEAR_REDUX:
            return ["", "PACKAGE_OVERVIEW"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};